import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(-360deg);
  }
`;

export const Container = styled.section`
  align-items: center;
  border-radius: 5px;
  box-shadow: 0 1px 2px 0 rgb(1 1 1 / 40%);
  display: inline-flex;
  flex-direction: column;
  min-width: 250px;
  max-width: 650px;
`;
Container.displayName = 'Container';

export const RouletteImage = styled.img`
  animation: ${rotate} 15s linear infinite;
  left: 26%;
  position: absolute;
  top: 26%;
  user-drag: none;
  width: 48%;
  z-index: 5;
`;
RouletteImage.displayName = 'RouletteImage';

export const Time = styled.div`
  align-items: center;
  border-radius: ${({ haveTitle }) => (haveTitle ? '5px 5px 0 0' : '5px')};
  display: flex;
  font-size: 48px;
  font-family: Arial, Helvetica, sans-serif;
  justify-content: center;
  padding: 8px 0;
  text-align: center;
  text-shadow: 1px 1px 0px #ccc;
  width: 100%;
`;
Time.displayName = 'Time';

export const Title = styled.div`
  border-radius: 0 0 5px 5px;
  font-size: 15px;
  font-family: Arial, Helvetica, sans-serif;
  letter-spacing: 2px;
  padding: 12px 8px;
`;
Title.displayName = 'Title';
